export const FUNCTIONALITY_NOT_SUPPORTED =
  'This functionality is not supported for the selected contract.';
